"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VouchersTable = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(VouchersTable, _Component);

  function VouchersTable(props) {
    (0, _classCallCheck3.default)(this, VouchersTable);

    var _this = (0, _possibleConstructorReturn3.default)(this, (VouchersTable.__proto__ || (0, _getPrototypeOf2.default)(VouchersTable)).call(this, props));

    _this.handlePreview = function (number, event) {
      event.preventDefault();
      _this.props.handlePreview(number);
    };

    return _this;
  }

  (0, _createClass3.default)(VouchersTable, [{
    key: "render",
    value: function render() {
      var voucher = this.props.voucher;

      return _react2.default.createElement(
        "table",
        { className: "table vouchers-table" },
        _react2.default.createElement(
          "thead",
          null,
          _react2.default.createElement(
            "tr",
            null,
            _react2.default.createElement("th", null),
            _react2.default.createElement(
              "th",
              null,
              "Nro:"
            ),
            _react2.default.createElement(
              "th",
              null,
              "Vastaanottopaikka:"
            ),
            _react2.default.createElement(
              "th",
              null,
              "Tiedot:"
            )
          )
        ),
        this.renderRows()
      );
    }
  }, {
    key: "renderRows",
    value: function renderRows() {
      var rows = [];
      var voucher = this.props.voucher;

      var used = 0;
      for (var i = 0; i < voucher.quantity; i++) {
        var number = voucher.first_voucher_id + i;
        rows.push(_react2.default.createElement(
          "tr",
          { key: i, className: "voucher-row-js" },
          _react2.default.createElement(
            "td",
            null,
            _react2.default.createElement(
              "div",
              { className: "form-group form-group-voucher" },
              i < voucher.quantity_printed ? "Tulostettu" : "Käytettävissä"
            )
          ),
          _react2.default.createElement(
            "td",
            null,
            number
          ),
          _react2.default.createElement(
            "td",
            null,
            voucher.name
          ),
          _react2.default.createElement(
            "td",
            null,
            _react2.default.createElement(
              "a",
              {
                href: "#",
                className: number + "-info-js",
                onClick: this.handlePreview.bind(this, number)
              },
              "Tiedot"
            )
          )
        ));
      }
      return _react2.default.createElement(
        "tbody",
        null,
        rows
      );
    }
  }]);
  return VouchersTable;
}(_react.Component), _class.propTypes = {
  voucher: _react.PropTypes.object.isRequired,
  numbers: _react.PropTypes.object.isRequired,
  toggleNumber: _react.PropTypes.func.isRequired,
  handlePreview: _react.PropTypes.func.isRequired,
  location: _react.PropTypes.object.isRequired
}, _temp);
exports.default = VouchersTable;
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/uservouchers/VouchersTable.js
 ** module id = 1198
 ** module chunks = 0
 **/